import { render, staticRenderFns } from "./BlockBackground.vue?vue&type=template&id=52dc1f1a&"
import script from "./BlockBackground.vue?vue&type=script&lang=js&"
export * from "./BlockBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlockBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports